
import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useNavigate } from 'react-router';

import { Button, CircularProgress, Dialog, DialogActions, DialogContent, FormControl, Grid, IconButton, InputLabel, MenuItem, Paper, Select, Switch, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TextField, Typography } from '@mui/material';

import EditIcon from '@mui/icons-material/Edit';
import UndoIcon from '@mui/icons-material/Undo';

import { TablePaginationActions } from '../../helpers/TablePaginationActions';

import { usePages } from '../../hooks/usePages';
import { useFilter } from '../../hooks/useFilter';

import { RootState } from '../../store';
import { openSnackbar } from '../../store/slices/SnackbarSlice';

import { TablePaddingStyle, TableTheadStyle } from '../../styles/TableStyle';
import { DialogActionsStyle, DialogContentStyle } from '../../styles/DialogStyle';

import { Layout } from '../../components/Layout';
import { SearchTextField } from '../../components/SearchTextField';

import { ActualizarAsentamiento, AgregarAsentamiento, Asentamientos } from '../../connections/catalogos/AsentamientoConnection';
import { ObtenerMunicipio } from '../../connections/catalogos/MunicipioConnection';
import { ObtenerZona } from '../../connections/catalogos/ZonaConnection';
import { ObtenerTiposAsentamientos } from '../../connections/catalogos/TipoAsentamientoConnection';
import { ObtenerCiudad } from '../../connections/catalogos/CiudadConnection';
import { ObtenerEstados } from '../../connections/catalogos/EstadoConnection';

import { AsentamientoProps } from '../../interfaces/catalogos/AsentamientoInterface';
import { EstadoProps } from '../../interfaces/catalogos/EstadoInterface';
import { MunicipioProps } from '../../interfaces/catalogos/MunicipioInterface';
import { CiudadProps } from '../../interfaces/catalogos/CiudadInterface';
import { ZonaProps } from '../../interfaces/catalogos/ZonaInterface';
import { TipoAsentamientoProps } from '../../interfaces/catalogos/TipoAsentamientoInterface';

type OptionType = 'Agregar' | 'Editar';

export const AsentamientoPage = () => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const { administrador, coordinador } = useSelector( ( state: RootState ) => state.auth );

    const [asentamientoArray, setAsentamientoArray] = useState<AsentamientoProps[]>( [] );

    const [referencia, setReferencia] = useState<number>( 0 );
    const [opcion, setOpcion] = useState<OptionType>( 'Agregar' );

    const [openDialog, setOpenDialog] = useState( false );
    const [loading, setLoading] = useState( false );
    const [loadingData, setLoadingData] = useState( true );

    const [estado, setEstado] = useState<number>( 0 );
    const [estadoArray, setEstadoArray] = useState<EstadoProps[]>( [] );

    const [municipio, setMunicipio] = useState<number>( 0 );
    const [municipioTemp, setMunicipioTemp] = useState<number>( 0 );
    const [municipioArray, setMunicipioArray] = useState<MunicipioProps[]>( [] );

    const [ciudad, setCiudad] = useState<number>( 0 );
    const [ciudadTemp, setCiudadTemp] = useState<number>( 0 );
    const [ciudadArray, setCiudadArray] = useState<CiudadProps[]>( [] );

    const [tipoAsentamiento, setTipoAsentamiento] = useState<number>( 0 );
    const [tipoAsentamientoArray, setTipoAsentamientoArray] = useState<TipoAsentamientoProps[]>( [] );

    const [zona, setZona] = useState<number>( 0 );
    const [zonaArray, setZonaArray] = useState<ZonaProps[]>( [] );

    const [descripcion, setDescripcion] = useState<string>( '' );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages(5);

    const [filtroTipoAsentamiento, setFiltroTipoAsentamiento] = useState( '' );
    const [filtroEstado, setFiltroEstado] = useState( '' );
    const [filtroMunicipio, setFiltroMunicipio] = useState( '' );
    const [filtroCiudad, setFiltroCiudad] = useState( '' );
    const [filtroZona, setFiltroZona] = useState( '' );

    const { filtro, setFiltro, dataFiltrada } = useFilter( asentamientoArray, ( item, filtro ) => {
        const f = filtro.toLowerCase();
        const fta = filtroTipoAsentamiento.toLowerCase();
        const fe = filtroEstado.toLowerCase();
        const fm = filtroMunicipio.toLowerCase();
        const fc = filtroCiudad.toLowerCase();
        const fz = filtroZona.toLowerCase();
        return (
            ( filtro === '' || ( item.descripcion?.toLowerCase().includes( f ) ?? false ) ) &&
            ( filtroTipoAsentamiento === '' || ( item.tipoAsentamiento?.descripcion?.toLowerCase().includes( fta ) ?? false ) ) &&
            ( filtroEstado === '' || ( item.estado?.descripcion?.toLowerCase().includes( fe ) ?? false ) ) &&
            ( filtroMunicipio === '' || ( item.municipio?.descripcion?.toLowerCase().includes( fm ) ?? false ) ) &&
            ( filtroCiudad === '' || ( item.ciudad?.descripcion?.toLowerCase().includes( fc ) ?? false ) ) &&
            ( filtroZona === '' || ( item.zona?.descripcion?.toLowerCase().includes( fz ) ?? false ) )
        );
    });

    const [codigoPostal, setCodigoPostal] = useState<string>( '' );

    const handleChangeChecked = async (checked: boolean, id: number) => {

        const asentamientoSelected = asentamientoArray.find((elem) => elem.idAsentamiento === id);

        if (asentamientoSelected) {

            await ActualizarAsentamiento({ ...asentamientoSelected, activo: checked }).then(resp => {

                if (resp.idAsentamiento) {

                    var newArray = asentamientoArray.map((elem) => {

                        if (elem.idAsentamiento === id) {
                            elem.activo = checked;
                        }

                        return elem;
                    });

                    setAsentamientoArray(newArray);

                    dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' }));

                }

            });
        }

    }

    const EditarRegistro = ({ idAsentamiento, descripcion, codigoPostal, idEstado, idMunicipio, idCiudad, idTipoAsentamiento, idZona }: AsentamientoProps ) => {

        setCodigoPostal(codigoPostal);
        setDescripcion(descripcion);

        setEstado(idEstado);
        setMunicipioTemp(idMunicipio);
        setCiudadTemp(idCiudad ?? 0);
        setZona(idZona)

        setTipoAsentamiento(idTipoAsentamiento);

        setOpcion( 'Editar' );
        setReferencia(idAsentamiento);

        setOpenDialog( true );
    }

    const AgregarRegistro = () => {

        setEstado( 0 );
        setMunicipio( 0 );
        setCiudad( 0 );
        setTipoAsentamiento( 0 );
        setCodigoPostal( '' );
        setDescripcion( '' );
        setZona( 0 )

        setOpcion( 'Agregar' );
        setReferencia( 0 );

        setOpenDialog( true );
    }

    const Guardar = async () => {

        setLoading( true );

        if ( opcion === 'Agregar' ) {

            const params: AsentamientoProps = {
                idAsentamiento: 0,
                clave: '',
                codigoPostal: codigoPostal,
                descripcion: descripcion.trim(),
                idEstado: estado,
                idMunicipio: municipio,
                idCiudad: ciudad,
                idTipoAsentamiento: tipoAsentamiento,
                activo: true,
                idZona: zona
            };

            await AgregarAsentamiento( params ).then(resp => {

                if ( resp ) {

                    setTimeout(() => {

                        setAsentamientoArray([
                            ...asentamientoArray,
                            {
                                idAsentamiento: resp.idAsentamiento,
                                idEstado: resp.idEstado,
                                idMunicipio: resp.idMunicipio,
                                idCiudad: resp.idCiudad,
                                idTipoAsentamiento: resp.idTipoAsentamiento,
                                estado: resp.estado,
                                municipio: resp.municipio,
                                ciudad: resp.ciudad,
                                tipoAsentamiento: resp.tipoAsentamiento,
                                clave: resp.clave,
                                codigoPostal: codigoPostal,
                                descripcion: descripcion,
                                activo: true,
                                idZona: zona
                            }
                        ]);

                        setLoading( false );
                        setOpenDialog( false );

                        dispatch( openSnackbar({ message: 'Se agregó el asentamiento correctamente', variant: 'success' }));

                    }, 400);

                }

            });
        }
        else if ( opcion === 'Editar' ) {

            const asentamiento = asentamientoArray.find( ( row ) => row.idAsentamiento === referencia );

            const params: AsentamientoProps = {
                idAsentamiento: referencia,
                idEstado: estado,
                idMunicipio: municipio,
                idCiudad: ciudad,
                idTipoAsentamiento: tipoAsentamiento,
                clave: asentamiento?.clave ?? '',
                codigoPostal: codigoPostal,
                descripcion: descripcion.trim(),
                activo: asentamiento?.activo ?? false,
                idZona: zona
            };

            await ActualizarAsentamiento(params).then(resp => {

                if ( resp ) {

                    setTimeout(() => {

                        const newRows = asentamientoArray.map( ( row ) => {

                            if ( row.idAsentamiento === referencia ) {

                                row.clave = resp.clave;
                                row.codigoPostal = codigoPostal;
                                row.descripcion = descripcion;
                                row.idEstado = resp.idEstado;
                                row.estado = resp.estado;
                                row.idMunicipio = resp.idMunicipio;
                                row.municipio = resp.municipio;
                                row.idCiudad = resp.idCiudad;
                                row.ciudad = resp.ciudad;
                                row.idTipoAsentamiento = resp.idTipoAsentamiento;
                                row.tipoAsentamiento = resp.tipoAsentamiento;
                                row.idZona = zona;
                                row.zona = resp.zona

                                return row;
                            }

                            return row;
                        });

                        setAsentamientoArray( newRows );

                        setLoading( false );
                        setOpenDialog( false );

                        dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' }));

                    }, 400);

                }

            });
        }
    }

    useEffect(() => {

        async function Obtener() {

            setLoadingData( true );
            setAsentamientoArray( [] );

            await Asentamientos().then( resp => {

                setTimeout(() => {

                    setAsentamientoArray( resp );
                    setLoadingData( false );

                }, 700);

            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            await ObtenerZona().then( resp => {

                if ( resp ) {

                    setZonaArray( resp );
                }

            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            await ObtenerEstados().then( resp  => {

                if ( resp ) {

                    setEstadoArray( resp );
                }

            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            setCiudad( 0 );
            setMunicipio( 0 );

            if ( estado !== 0 ) {

                await ObtenerMunicipio( estado ).then( resp  => {
                    setMunicipioArray( resp );
                });

            }

        }

        Obtener();

    }, [estado]);

    useEffect(() => {

        async function Obtener() {

            await ObtenerTiposAsentamientos().then( resp => {
                setTipoAsentamientoArray( resp );
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            setCiudad( 0 );

            if ( estado !== 0 && municipio !== 0 ) {

                const params = {
                    idEstado: estado,
                    idMunicipio: municipio,
                };

                await ObtenerCiudad( params ).then( resp  => {
                    setCiudadArray( resp );
                });
            }

        }

        Obtener();

    }, [estado, municipio]);

    useEffect(() => {

        if (estado !== 0 && municipioTemp !== 0 && municipioArray.length !== 0) {
            setMunicipio(municipioTemp);
        }

    }, [estado, municipioTemp, municipioArray]);

    useEffect(() => {

        if (estado !== 0 && municipio !== 0 && ciudadTemp !== 0 && ciudadArray.length !== 0) {
            setCiudad(ciudadTemp);
        }

    }, [estado, municipio, ciudadTemp, ciudadArray]);

    return (

        <Layout breadcrumbs={ [ { text: 'Administración' }, { text: 'Catálogos' }, { text: 'Asentamiento' } ] } backgroundPaper={ false }>

            <Grid container spacing={ 3 }>

                <Grid size={{ md: 6, xs: 12 }} textAlign={ 'start' }>

                    {
                        ( administrador || coordinador )
                        &&
                            <Button startIcon={ <UndoIcon /> } color='secondary' variant='text' sx={{ mt: 1 }} onClick={ () => navigate('/') }>
                                Regresar
                            </Button>
                    }

                </Grid>

                <Grid size={{ md: 6, xs: 12 }} textAlign={ 'end' }>

                    <Button
                        type='button'
                        variant='contained'
                        sx={{ mt: 1 }}
                        disabled={ loadingData }
                        onClick={ AgregarRegistro }
                    >
                        Agregar
                    </Button>

                </Grid>

            </Grid>

            <Grid container sx={{ mt: 2 }} spacing={ 2 }>

                <Grid size={{ xs: 12, md: 4 }}>

                    <SearchTextField
                        value={ filtro }
                        label='Buscar por descripción'
                        onChange={ ( value ) => {
                            setFiltro( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />

                </Grid>

                <Grid size={{ xs: 12, md: 4 }}>

                    <SearchTextField
                        value={ filtroTipoAsentamiento }
                        label='Buscar por tipo de asentamiento'
                        onChange={ ( value ) => {
                            setFiltroTipoAsentamiento( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />

                </Grid>

                <Grid size={{ xs: 12, md: 4 }}>

                    <SearchTextField
                        value={ filtroEstado }
                        label='Buscar por estado'
                        onChange={ ( value ) => {
                            setFiltroEstado( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />

                </Grid>

                <Grid size={{ xs: 12, md: 4 }}>

                    <SearchTextField
                        value={ filtroMunicipio }
                        label='Buscar por municipio'
                        onChange={ ( value ) => {
                            setFiltroMunicipio( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />

                </Grid>

                <Grid size={{ xs: 12, md: 4 }}>

                    <SearchTextField
                        value={ filtroCiudad }
                        label='Buscar por ciudad'
                        onChange={ ( value ) => {
                            setFiltroCiudad( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />

                </Grid>

                <Grid size={{ xs: 12, md: 4 }}>

                    <SearchTextField
                        value={ filtroZona }
                        label='Buscar por zona'
                        onChange={ ( value ) => {
                            setFiltroZona( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />

                </Grid>

            </Grid>

            <TableContainer sx={{ mt: 3, borderRadius: 3 }} component={ Paper }>

                <Table sx={{ minWidth: 500 }}>

                    <TableHead sx={{ ...TableTheadStyle }}>

                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '5%', textAlign: 'center' }}> Id </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '5%' }}> Clave </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%' }}> Descripción </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%' }}> Código postal </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%' }}> Tipo de asentamiento </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%' }}> Estado </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%' }}> Municipio </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%' }}>  </TableCell>

                        </TableRow>

                    </TableHead>

                    <TableBody>

                        {
                            (rowsPerPage > 0
                                ? dataFiltrada.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                : dataFiltrada
                            ).map((row) => (
                                <TableRow key={ row.idAsentamiento } >

                                    <TableCell style={{ fontWeight: 'bold', textAlign: 'center' }}>
                                        {row.idAsentamiento}
                                    </TableCell>

                                    <TableCell>
                                        {row.clave}
                                    </TableCell>

                                    <TableCell>
                                        {row.descripcion}
                                    </TableCell>

                                    <TableCell>
                                        {row.codigoPostal}
                                    </TableCell>

                                    <TableCell>
                                        {row.tipoAsentamiento?.descripcion}
                                    </TableCell>

                                    <TableCell>
                                        {row.estado?.descripcion}
                                    </TableCell>

                                    <TableCell>
                                        {row.municipio?.descripcion}
                                    </TableCell>

                                    <TableCell sx={{ textAlign: 'end' }}>

                                        <Switch
                                            checked={ row.activo }
                                            onChange={ (e) => handleChangeChecked(e.target.checked, row.idAsentamiento) }
                                        />

                                        <IconButton
                                            color='primary'
                                            aria-label='edit'
                                            component='span'
                                            onClick={ () => EditarRegistro(row) }
                                        >
                                            <EditIcon />
                                        </IconButton>

                                    </TableCell>

                                </TableRow>
                            ))}

                        {
                            ( dataFiltrada.length === 0 && !loadingData )
                            ?
                                <TableRow style={{ height: 73 }}>

                                    <TableCell colSpan={ 7 } align='center'>

                                        <Typography variant='caption' color='secondary'> No se encontraron resultados </Typography>

                                    </TableCell>

                                </TableRow>
                            :
                                loadingData
                                &&
                                    <TableRow style={{ height: 73 }}>

                                        <TableCell colSpan={ 7 } align='center'>

                                            <CircularProgress size={ 32 } />

                                        </TableCell>

                                    </TableRow>
                        }

                    </TableBody>

                    <TableFooter>

                        {
                            dataFiltrada.length !== 0
                            &&
                            <TableRow>

                                <TableCell colSpan={ 3 } sx={{ border: 'none' }}>
                                    <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}>
                                        Total de registros: {dataFiltrada.length}
                                    </Typography>
                                </TableCell>

                                <TablePagination
                                    sx={{ border: 'none' }}
                                    rowsPerPageOptions={  [ 5, 10, 15, 25, 50, 75, 100, 150, 200, 500] }
                                    colSpan={ 8 }
                                    count={ dataFiltrada.length }
                                    rowsPerPage={ rowsPerPage }
                                    page={ page }

                                    onPageChange={ handleChangePage }
                                    onRowsPerPageChange={ handleChangeRowsPerPage }

                                    ActionsComponent={ TablePaginationActions }

                                    labelRowsPerPage='Filas por página'
                                    labelDisplayedRows={
                                        ({ from, to, count }) => {
                                            return '' + from + '-' + to + ' de ' + count
                                        }
                                    }
                                />

                            </TableRow>
                        }

                    </TableFooter>

                </Table>

            </TableContainer>

            <Dialog open={ openDialog } maxWidth='sm' fullWidth={ true }>

                <DialogContent sx={ DialogContentStyle }>

                    <Grid container spacing={ 3 } mt={ 3 }>

                        <Grid size={{ md: 6, xs: 12 }} >

                            <FormControl fullWidth >
                                <InputLabel id="select-estado-label">Estado</InputLabel>

                                <Select
                                    label='Estado'
                                    value={ estado }
                                    onChange={(e) => { setEstado(e.target.value ?? 0); }}
                                >
                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                    {
                                        estadoArray.map((elem) => (
                                            <MenuItem key={ elem.idEstado } value={ elem.idEstado }> {elem.descripcion} </MenuItem>
                                        ))
                                    }
                                </Select>

                            </FormControl>

                        </Grid>

                        <Grid size={{ md: 6, xs: 12 }} >

                            <FormControl fullWidth>
                                <InputLabel id="select-municipio-label">Municipio</InputLabel>

                                <Select
                                    label='Municipio'
                                    value={ municipio }
                                    onChange={(e) => { setMunicipio(e.target.value ?? 0); }}
                                    disabled={ estado === 0 }
                                >
                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                    {
                                        municipioArray.map((elem) => (
                                            <MenuItem key={ elem.idMunicipio } value={ elem.idMunicipio }> {elem.descripcion} </MenuItem>
                                        ))
                                    }
                                </Select>

                            </FormControl>

                        </Grid>

                        <Grid size={{ md: 6, xs: 12 }} >

                            <FormControl fullWidth>
                                <InputLabel id="select-ciudad-label">Ciudad</InputLabel>

                                <Select
                                    label='Ciudad'
                                    value={ ciudad }
                                    onChange={(e) => { setCiudad(e.target.value ?? 0); }}
                                    disabled={ estado === 0 }
                                >
                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                    {
                                        ciudadArray.map((elem) => (
                                            <MenuItem key={ elem.idCiudad } value={ elem.idCiudad }> {elem.descripcion} </MenuItem>
                                        ))
                                    }
                                </Select>

                            </FormControl>

                        </Grid>

                        <Grid size={{ md: 6, xs: 12 }} >

                            <FormControl fullWidth>

                                <TextField
                                    label='Código postal'
                                    variant='outlined'
                                    required
                                    value={ codigoPostal }
                                    onChange={(e) => { setCodigoPostal(e.target.value) }}
                                    slotProps={{
                                        input: {
                                            autoComplete: 'off'
                                        },
                                        inputLabel: {
                                            shrink: true,
                                        }
                                    }}
                                />

                            </FormControl>

                        </Grid>

                        <Grid size={{ md: 6, xs: 12 }} >

                            <FormControl fullWidth>
                                <InputLabel id="select-tipoAsentamiento-label">Tipo de asentamiento</InputLabel>

                                <Select
                                    label={ 'Tipo de asentamiento' }
                                    value={ tipoAsentamiento }
                                    onChange={(e) => { setTipoAsentamiento(e.target.value ?? 0); }}
                                >
                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                    {
                                        tipoAsentamientoArray.map((elem) => (
                                            <MenuItem key={ elem.idTipoAsentamiento } value={ elem.idTipoAsentamiento }> {elem.descripcion} </MenuItem>
                                        ))
                                    }
                                </Select>

                            </FormControl>

                        </Grid>

                        <Grid size={{ md: 6, xs: 12 }} >

                            <FormControl fullWidth>
                                <InputLabel id="select-zona-label">Zona</InputLabel>

                                <Select
                                    label='Zona'
                                    value={ zona }
                                    onChange={(e) => { setZona(e.target.value ?? 0); }}
                                >
                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                    {
                                        zonaArray.map((elem) => (
                                            <MenuItem key={ elem.idZona } value={ elem.idZona }> {elem.descripcion} </MenuItem>
                                        ))
                                    }
                                </Select>

                            </FormControl>

                        </Grid>

                        <Grid size={{ md: 12, xs: 12 }} >

                            <FormControl fullWidth>

                                <TextField
                                    label={ 'Descripción' }
                                    variant='outlined'
                                    multiline
                                    rows={ 4 }
                                    fullWidth
                                    value={ descripcion }
                                    onChange={ (e) => setDescripcion(e.target.value) }
                                    slotProps={{
                                        input: {
                                            autoComplete: 'off'
                                        },
                                        inputLabel: {
                                            shrink: true,
                                        }
                                    }}
                                />

                            </FormControl>

                        </Grid>

                    </Grid>

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>
                    <Button color='secondary' disabled={ loading } onClick={ () => setOpenDialog( false ) }> Cancelar </Button>
                    <Button
                        variant='contained'
                        loading={ loading }
                        disabled={ descripcion === '' || municipio === 0 || estado === 0 || zona === 0 }
                        onClick={ Guardar }
                    >
                        Guardar
                    </Button>
                </DialogActions>

            </Dialog>

        </Layout>

    )
}
